import { Link } from 'react-router-dom';
import { CheckCircle, XCircle, Eye, Trash, ArrowUUpLeft } from '@phosphor-icons/react';
import { statusBadgeClass } from './AdminUI';
import CategoryBadges from '../CategoryBadges';

const StatusPill = ({ status }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full border font-semibold uppercase ${statusBadgeClass(status)}`}>
    {(status || '').replace('_', ' ')}
  </span>
);

const ModerationActions = ({ tournament, onApprove, onReject, onRequestArchive, onRequestRejectDeletion }) => {
  const t = tournament;
  if (t.status === 'pending_approval') {
    return (
      <>
        <button
          onClick={() => onApprove(t.tournament_id)}
          className="inline-flex items-center gap-1.5 bg-green-50 hover:bg-green-100 text-green-700 px-3 py-2 rounded-lg text-xs font-semibold"
          data-testid={`approve-btn-${t._index}`}
        >
          <CheckCircle size={14} weight="bold" /> Approve
        </button>
        <button
          onClick={() => onReject(t.tournament_id)}
          className="inline-flex items-center gap-1.5 bg-orange-50 hover:bg-orange-100 text-orange-700 px-3 py-2 rounded-lg text-xs font-semibold"
          data-testid={`reject-btn-${t._index}`}
        >
          <XCircle size={14} weight="bold" /> Reject
        </button>
      </>
    );
  }
  if (t.status === 'deletion_requested') {
    return (
      <>
        <button
          onClick={() => onRequestArchive({ tournament_id: t.tournament_id, name: t.name })}
          className="inline-flex items-center gap-1.5 bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-xs font-semibold"
          data-testid={`approve-deletion-btn-${t._index}`}
        >
          <CheckCircle size={14} weight="bold" /> Approve Deletion
        </button>
        <button
          onClick={() => onRequestRejectDeletion({ tournament_id: t.tournament_id, name: t.name })}
          className="inline-flex items-center gap-1.5 bg-gray-100 hover:bg-gray-200 text-gray-800 px-3 py-2 rounded-lg text-xs font-semibold"
          data-testid={`reject-deletion-btn-${t._index}`}
        >
          <ArrowUUpLeft size={14} weight="bold" /> Reject Request
        </button>
      </>
    );
  }
  if (t.status === 'approved' || t.status === 'rejected') {
    return (
      <button
        onClick={() => onRequestArchive({ tournament_id: t.tournament_id, name: t.name })}
        className="inline-flex items-center gap-1.5 bg-red-50 hover:bg-red-100 text-red-700 px-3 py-2 rounded-lg text-xs font-semibold"
        data-testid={`delete-btn-${t._index}`}
      >
        <Trash size={14} weight="bold" /> Archive
      </button>
    );
  }
  return null;
};

const TournamentModerationCard = ({ tournament, index, onApprove, onReject, onRequestArchive, onRequestRejectDeletion }) => {
  const t = { ...tournament, _index: index };
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-5" data-testid={`tournament-${index}`}>
      <div className="flex flex-col md:flex-row md:items-start gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <h3 className="font-bold text-gray-900">{t.name}</h3>
            <StatusPill status={t.status} />
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-orange-50 text-orange-700 font-semibold uppercase border border-orange-100">{t.format}</span>
          </div>
          <CategoryBadges ages={t.age_categories || []} genders={t.gender_categories || []} className="mb-2" />
          <div className="text-sm text-gray-500 flex flex-wrap gap-x-4 gap-y-1">
            <span>{t.city}, {t.state}</span>
            <span>{t.organizer_name}</span>
            <span>{t.dates}</span>
          </div>
          {t.status === 'deletion_requested' && t.deletion_reason && (
            <p className="text-xs text-red-700 bg-red-50 border border-red-100 rounded-lg px-3 py-1.5 mt-2">
              Organizer note: {t.deletion_reason}
            </p>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          <Link
            to={`/tournaments/${t.tournament_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 bg-gray-50 hover:bg-gray-100 text-gray-700 px-3 py-2 rounded-lg text-xs font-semibold"
            data-testid={`view-btn-${index}`}
          >
            <Eye size={14} weight="bold" /> View
          </Link>
          <ModerationActions
            tournament={t}
            onApprove={onApprove}
            onReject={onReject}
            onRequestArchive={onRequestArchive}
            onRequestRejectDeletion={onRequestRejectDeletion}
          />
        </div>
      </div>
    </div>
  );
};

export default TournamentModerationCard;
